import React from 'react';

const PageNotFound = () => (
    <section className="PageNotFound">
        <p>No se ha encontrado la página a la que intenta acceder.</p>
    </section>
);

export default PageNotFound;
